"use client";

import {FallbackProps} from 'react-error-boundary';

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
	return (
		<>
			<h1>Something went wrong</h1>
			<div>{error.message}</div>
			<button onClick={resetErrorBoundary}>Try again</button>
		</>
	);
};

export default Fallback;
